import { Check } from "lucide-react";
import { toast } from "sonner";

import type { StageStatus } from "@/adapters/api";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useUpdateStage } from "../../hooks/use-update-stage.ts";
import type { Stage } from "../../types.ts";
import { STAGE_STATUS, STAGE_STATUSES } from "../../utils/status.ts";
import { StatusBadge } from "../status-badge";

export function StatusMenu({
	constructionId,
	stage,
}: {
	constructionId: string;
	stage: Stage;
}) {
	const { mutate, isPending } = useUpdateStage(constructionId);

	function changeStatus(status: StageStatus) {
		if (status === stage.status) return;
		mutate(
			{ stageId: stage.id, input: { status } },
			{
				onSuccess: () => toast.success("Status atualizado com sucesso!"),
				onError: () => toast.error("Houve um erro ao atualizar o status."),
			},
		);
	}

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<button
					type="button"
					disabled={isPending}
					aria-label={`Alterar status de ${stage.name}`}
					className="status-menu__trigger"
				>
					<StatusBadge status={stage.status} withChevron />
				</button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="start">
				{STAGE_STATUSES.map((status) => (
					<DropdownMenuItem key={status} onClick={() => changeStatus(status)}>
						<span aria-hidden className="status-dot" data-status={status} />
						{STAGE_STATUS[status].label}
						{status === stage.status && (
							<Check className="status-menu__check" />
						)}
					</DropdownMenuItem>
				))}
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
